import * as types from '../mutation-types'

export default {
	namespaced: true,

	state: {
		allProjects: [],
		statsProjects: {
			contributed_users: [],
			tags: []
		},
		projectWork: [],
		projectsByUserId: [],
		currentUserProjects: [],
		projectsBrief: []
	},

	actions: {
		fetchAll ({ commit }, { CategoryIds, IsActive, UserId, NonDeleted, Page, PerPage, name }) {
			const urlSearchParams = new URLSearchParams();
			const params = { IsActive, NonDeleted, Page, PerPage, name }

			Object.keys(params).forEach(param => {
				if (params[param] !== null && params[param] !== undefined) urlSearchParams.append(param, params[param])
			});
		
			CategoryIds.forEach(id => {
				urlSearchParams.append('CategoryIds', id)
			})

			UserId.forEach(id => {
				urlSearchParams.append('UserId', id)
			})
            
			return window.axios.get('/projects', { params: urlSearchParams }).then((response) => {
				commit(types.STORE_PROJECT, response.data)
				console.log(response)
				return {
					data: response.data,
					total: parseInt(response.headers['x-pagination-total-count'])
				}
			})
		},

		fetchById ({ commit }, { id }) {
			return window.axios.get(`/Projects/${id}`).then(({ data }) => {
				return data
			})
		},

		fetchProjectByPage ({ commit }, { page }) {
			return window.axios.get('/projects', { 
				params: { page } 
			}).then(({ data }) => {
				return data
			})
		},

		fetchStatsProjects ({ commit }, { id }) {
			return window.axios.get(`/projects/${id}/stats`).then(({ data }) => {
				commit(types.STORE_STATS_PROJECT, data)
				return data
			})
		},

		create ({ commit }, { name, categoryId, isActive, projectTeamIds, numOfTask, spentTime, keywordIds, projectTeams, lastUpdate }) {
			return window.axios.post('/projects', { name, categoryId, isActive, projectTeamIds, numOfTask, spentTime, keywordIds, projectTeams, lastUpdate }).then(({ data }) => {
				return data
			})
		},

		// update ({ commit }, { id, _method }) {
		// 	return window.axios.post(`/projects/${id}`, {
		// 		_method: 'PUT'
		// 	})
		// },
		update ({ commit }, { id, name, categoryId, isActive, projectTeamIds, numOfTask, spentTime, keywordIds, projectTeams, lastUpdate }) {
			return window.axios.put(`/projects/${id}`, { name, categoryId, isActive, projectTeamIds, numOfTask, spentTime, keywordIds, projectTeams, lastUpdate }).then(({ data }) => {
				return data
			})
		},
		
		fetchAllWork ({ commit }) {
			return window.axios.get('projects/all/work').then(({ data }) => {
				commit(types.STORE_WORK_DAY, data)
				return data
			})
		},

		changProjectState ({ commit }, { id, _method }) {
			return window.axios.post(`/projects/${id}/change-status`, { _method: 'PUT' }).then(({ data }) => {
				return data
			})
		},

		delete ({ commit }, { id }) {
			return window.axios.delete(`projects/${id}`)
		},

		fetchProjectByUser ({ commit }, { employeeIds }) {
			const urlSearchParams = new URLSearchParams();
			employeeIds.forEach(employeeIds => {
				urlSearchParams.append('employeeIds', employeeIds)
			})
			return window.axios.get('/Projects/TeamProjects', { params: urlSearchParams }).then(({ data }) => {
				commit(types.STORE_PROJECTS_BY_USER_ID, data)
				return data
			})
		},

		fetchCurrentUserProjects ({ commit }) {
			return window.axios.get('/Projects/CurrentUserProjects').then(({ data }) => {
				commit(types.STORE_CURRENT_USER_PROJECTS, data) 
				return data
			})
		},
		
		updateStateProject ({ commit }, { id }) {
			return window.axios.put(`/Projects/ToggleStatus/${id}`, { 
				headers: {
					'Content-Type': 'application/json'
				}
			}).then(({ data }) => {
				return data
			})
		},

		// get project breif for administrtive
		fetchProjectBrief ({ commit }) {
			return window.axios.get('/Projects/Brief').then(({ data }) => {
				commit(types.STORE_PROJECT_BRIEF, data)
				return data
			})
		},

		fetchProjectById ({ commit }, { id }) {
			return window.axios.get(`/Projects/Category/${id}`).then(({ data }) => {
				return data
			})
		}
	},

	mutations: {
		[types.STORE_PROJECT] (state, allProjects) {
			state.allProjects = allProjects
		},

		[types.STORE_STATS_PROJECT] (state, statsProjects) {
			state.statsProjects = statsProjects
		},

		[types.STORE_WORK_DAY] (state, projectWork) {
			state.projectWork = projectWork
		},

		[types.STORE_PROJECTS_BY_USER_ID] (state, projectsByUserId) {
			state.projectsByUserId = projectsByUserId
		},

		[types.STORE_CURRENT_USER_PROJECTS] (state, currentUserProjects) {
			state.currentUserProjects = currentUserProjects
		},

		[types.STORE_PROJECT_BRIEF] (state, projectsBrief) {
			state.projectsBrief = projectsBrief
		}
	},

	getters: {
		getProjectById: state => id => state.projectsBrief.find(c => c.id === id),
		getProjectWorkById: state => id => state.projectWork.find(c => c.id === id),
		getProjectByUser: state => id => state.projectsByUserId.find(c => c.id === id)
	}
}
